<template>
<div class="down-card">
  <el-row :gutter="24">
    <el-col
      :lg="12"
      :sm="24"
      :xs="24"
    >
      <div class="card-left">
        <div class="title">{{mt4CardInfo.title}}</div>
        <div class="subtitle">{{mt4CardInfo.subtitle}}</div>
        <img
          class="big-img"
          :src="mt4CardInfo.imgBg" alt="">
      </div>
    </el-col>
    <el-col
      :lg="12"
      :sm="24"
      :xs="24"
    >
      <div class="list-link">
        <a
          v-for="(item,index) in mt4CardInfo.clienlists"
          :key="index"
          download target="_blank"
          :href="item.value"
          class="small-card">
          <div class="img-box">
            <svg
              class="svg-icon" style="font-size: 24px" aria-hidden="true" >
              <use :xlink:href="`#${item.symbol}`"></use>
            </svg>
          </div>
          <div class="right-box">
            <div class="three-title">{{item.smallText}}</div>
            <div class="desc">{{item.desc}}</div>
          </div>
        </a>
      </div>
    </el-col>
  </el-row>
</div>
</template>

<script>
import { getDictListByType } from '@/api/home.js';
export default {
  name: "mt4Card",
  props: {
    mt4CardInfo: {
      type: Object,
      default(){
        return {
          imgBg: '../../assets/images/customer/mt4Bg.png',
          title: 'MT4',
          subtitle: this.$t('download.subtitle'),
          clienlists: [
          {
            symbol: 'iconWindows',
            smallText: _this.$t('Windows_desktop_version'),
            desc: _this.$t('System_requirements_Applicable_to_Windows_2008_7_8_10_operating_system'),
            link: 'https://download.metatrader.com/cdn/web/maxain.group.limited/mt4/maxaingroup4setup.exe',
          },
          {
            symbol: 'iconiOS',
            smallText: _this.$t('Mac_desktop_version'),
            desc: _this.$t('System_requirements_Applicable_to_Mac_OS'),
            link: 'https://download.mql5.com/cdn/web/metaquotes.software.corp/mt4/MetaTrader4.dmg',
          },
          {
            symbol: 'iconAndroid',
            smallText: 'Android APK',
            desc: _this.$t('Download_instructions_After_downloading_you_can_install_the_APK_through_your_mobile_phone'),
            link: 'https://maxain-prod.s3-accelerate.amazonaws.com/files/MetaTrader4.apk'
          },
          {
            symbol: 'iconiOS',
            smallText: _this.$t('iOS_mobile_version'),
            desc: _this.$t('Download_instructions_iPhone_and_iPad_users_can_search_for_MetaTrader4_and_install_it_through_the_Apple_App_Store'),
            link: 'https://download.mql5.com/cdn/mobile/mt4/ios?server=MaxainGroup-Demo,MaxainGroup-Live'
          },
        ]
        }
      }
    },
  },
  created(){
    //     type参数值：
    // desktopMt4Client   桌面端
    // iosMt4Client            IOS端
    // androidMt4Client   安卓端
    this.getDictListByType('desktopMt4Client');
    this.getDictListByType('macOSMt4Client');
    this.getDictListByType('iosMt4Client');
    this.getDictListByType('androidMt4Client');
  },
  data() {
    return {
       
    }
  },
  methods:{
    getDictListByType(type){
      getDictListByType({
        type : type
      }).then((res) => {
        if(type == 'desktopMt4Client'){
          Object.assign(  this.mt4CardInfo.clienlists[0],res.data[0])
        }
        if(type == 'macOSMt4Client'){
          Object.assign(  this.mt4CardInfo.clienlists[1],res.data[0])
        }
        if(type == 'androidMt4Client'){
          Object.assign(  this.mt4CardInfo.clienlists[2],res.data[0])
        }
        if(type == 'iosMt4Client'){
          Object.assign(  this.mt4CardInfo.clienlists[3],res.data[0])
        }
        this.$forceUpdate();
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.down-card {
  margin-bottom: 20px;
  background-color: #ffffff;
  border-radius: 6px;
  padding: 24px;
  .title {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 10px;
    color: #5E5873;
  }
  .subtitle {
    color: #6E6B7B;
    font-size: 14px;
    margin-bottom: 24px;
  }
  .big-img {
    width: 100%;
  }
  .list-link {
    .small-card {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      border: 1px solid #EBE9F1;
      border-radius: 6px;
      padding: 20px;
      margin-bottom: 8px;
      .img-box {
        margin-right: 12px;
      }
      .icon-img {
        width: 30px;
      }
      .three-title {
        color: #6E6B7B;
        font-size: 14px;
      }
      .desc {
        color: #B9B9C3;
      }
    }
  }
}
</style>
